import script from "./MopilePhone.vue?vue&type=script&setup=true&lang=js"
export * from "./MopilePhone.vue?vue&type=script&setup=true&lang=js"

import "./MopilePhone.vue?vue&type=style&index=0&id=a7cbac0c&lang=css"

const __exports__ = script;

export default __exports__